import { createAction } from 'redux-actions';
import { TRIGGER_BULK_UPDATE_FAILURE_ALERT } from 'conversations-inbox-lib/threads-bulk-update/public/constants';
import { getBulkUpdateFailureAlert } from './getBulkUpdateFailureAlert';
export const triggerBulkUpdateFailureAlert = createAction(TRIGGER_BULK_UPDATE_FAILURE_ALERT, () => {}, () => ({
  notification: getBulkUpdateFailureAlert(),
  error: {
    ignore: true,
    silent: true
  }
}));